import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import IService from '@types_main/iservice';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { QuickReplyRequest } from './requests/quick-reply.request';
import { QuickReplyResponse } from './responses/quick-reply.response';

export class QuickReplyService extends BaseService implements IService<QuickReplyResponse> {
    protected get resourceName(): string {
        return 'crm/quick-replies';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<QuickReplyResponse>>> {
        return await this.get<PagedResponse<QuickReplyResponse>>('paginated' + (filter ?? ''), params);
    }

    public async getList(): Promise<AxiosResponse<{ data: QuickReplyResponse[] }>> {
        return await this.get('');
    }

    public async getById(id: string): Promise<AxiosResponse<{ data: QuickReplyResponse }>> {
        return await this.get(id);
    }

    public async create(body: QuickReplyRequest): Promise<AxiosResponse<{ data: QuickReplyResponse }>> {
        return await this.post(body);
    }

    public async update(
        id: string,
        body: QuickReplyRequest
    ): Promise<AxiosResponse<{ data: QuickReplyResponse }>> {
        return await this.put(id, body);
    }

    public async deleteById(id: string): Promise<AxiosResponse<void>> {
        return await this.delete(id);
    }
}
